import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { buildAtId } from "../../utils/utils";

import UnauthorisedFeature from "../../components/auth/UnauthorisedFeature.jsx";
import RedirectWithReset from "../../components/utils/RedirectWithReset.jsx";
import SimplePreloader from "../../components/preloaders/SimplePreloader.jsx";
import CreateImageForm from "../../components/images/CreateImageForm.jsx";

import { ROUTES } from "../../constants/routing.js";
import { AT_TYPES } from "../../constants/entity.js";
import { OPERATIONS } from "../../constants/operations.js";
import { ENTITIES, IMAGES } from "../../state/actions/actionConstants.js";

import { operationAction } from "../../state/reducers/operations/operationActions.js";
import { corePartRefreshAction } from "../../state/reducers/core/coreActions.js";
import { getResource } from "../../state/reducers/resources/resourcesActions.js";
import { getEntityAction } from "../../state/actions/entityActions.js";

import imageSelector from "../../state/reducers/images/imageSelector.js";
import { selectOperationAvailability } from "../../state/reducers/endpoints/endpointSelector.js";
import { selectLatestViolationErrors } from "../../state/reducers/api/apiSelectors.js";
import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class CreateImage extends Component {
  static propTypes = {
    data: PropTypes.object,
    isFetching: PropTypes.bool.isRequired,
    getEntityAction: PropTypes.func.isRequired,
    getResource: PropTypes.func.isRequired,
    createImageAvailability: PropTypes.object.isRequired,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "image"
  };

  constructor(props) {
    super(props);

    this.state = {
      dataAction: props.match.params.action,
      dataId: props.match.params.id,
      dataType: props.match.params.type,
      dataAtId: buildAtId(props.match.params),
      cancelPageAction: false
    };
  }

  componentDidMount = () => {
    const { dataAtId } = this.state;
    this.props.getEntityAction(dataAtId);
  };

  // -- HANDLERS -- //

  onCancel = () => {
    this.setState({ cancelPageAction: true });
  };

  onSubmit = values => {
    const { data, operationAction } = this.props;

    // "data" should already set on the operation "fields" object
    operationAction(data, OPERATIONS.CREATE_IMAGE, values, {
      success: corePartRefreshAction(IMAGES, AT_TYPES.IMAGE, true)
    });
  };

  // -- RENDER -- //

  render() {
    const { dataAtId, cancelPageAction } = this.state;

    const {
      data,
      isFetching,
      lastCreated,
      violationErrors,
      createImageAvailability,
      copyKey,
      copy
    } = this.props;

    // display unauthorised component if user diesn't have valid flags set
    if (!createImageAvailability.permitted) {
      return <UnauthorisedFeature title={copy(`${copyKey}.title`)} />;
    }

    // redirect to the images page on cancellation action
    if (cancelPageAction) {
      return <RedirectWithReset to={ROUTES.IMAGES} />;
    }

    // redirect for freshly created image
    if (lastCreated && lastCreated !== dataAtId && !isFetching) {
      return <RedirectWithReset to={lastCreated} />;
    }

    return (
      <Fragment>
        {isFetching && <SimplePreloader />}

        <CreateImageForm
          key={`createImageForm`}
          data={data}
          onCancel={this.onCancel}
          onSubmit={this.onSubmit}
          violationErrors={violationErrors}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state, props) => ({
  data: imageSelector.selectEntityByMatchProps(state, props),
  isFetching:
    state.ephemeralEntities.isFetching ||
    state.images.isFetching || // required to manage redirect on POST success
    state.account.isFetching, // required to manage redirect on POST success
  lastCreated: state.ephemeralEntities.lastCreated,
  violationErrors: selectLatestViolationErrors(state),
  createImageAvailability: selectOperationAvailability(state)(
    AT_TYPES.IMAGE,
    OPERATIONS.CREATE
  ),
  copy: selectCopy(state)
});

const mapDispatchToProps = dispatch => ({
  getEntityAction: (...args) => dispatch(getEntityAction(...args)),
  getResource: (...args) => dispatch(getResource(...args)),
  operationAction: (entity, operationName, data, options) =>
    dispatch(operationAction(ENTITIES, entity, operationName, data, options))
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateImage);
